import ZoneId from '../../../../../resources/zone_id';
import { OopsyData } from '../../../../../types/data';
import { OopsyTriggerSet } from '../../../../../types/oopsy';

export type Data = OopsyData;

// Fractal Continuum
const triggerSet: OopsyTriggerSet<Data> = {
  zoneId: ZoneId.TheFractalContinuum,
  damageWarn: {
    'Fractal Double Sever': 'F7D', // Conals, boss 1
    'Fractal Aetheric Compression': 'F80', // Ground AoE circles, boss 1
    'Fractal 11-Tonze Swipe': 'F81', // Frontal cone, boss 2
    'Fractal 10-Tonze Slash': 'F83', // Frontal line, boss 2
    'Fractal 111-Tonze Swing': 'F87', // Get-out AoE, boss 2
    'Fractal Broken Glass': 'F8E', // Glowing panels, boss 3
    'Fractal Mines': 'F90',
    'Fractal Seed of the Rivers': 'F91', // Ground AoE circles, boss 3
  },
  shareWarn: {
    'Fractal Sanctification': 'F89', // Instant conal buster, boss 3
  },
};

export default triggerSet;
